import React, { useRef, useEffect, useState } from 'react';
import Typed from 'typed.js';
import Testimonials from '../components/lander/testimonials';
import Pricing from '../components/lander/pricing';
import Footer from '../components/lander/footer';
import logo from '../assets/copybuddy-logo.png';
import svg from '../assets/Frame.svg';
import sparkles from '../assets/icons8-sparkle-24.png';
import { useNavigate } from 'react-router-dom';
import Featured from '../components/lander/featured';
import Demo from '../components/lander/demo';
import Faq from '../components/lander/faq';

function LandingPage() {
    const navigate = useNavigate();
    const typedRef = useRef(null);
    const [showParagraph, setShowParagraph] = useState(false);
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        const options = {
            strings: ["We research your prospects,<br /><b>you reach more prospects.</b>"],
            typeSpeed: 5,
            onComplete: () => {
                setTimeout(() => {
                    setShowParagraph(true);
                    setTimeout(() => {
                        setShowButton(true);
                    }, 100);
                }, 100);
            },
        };

        const typed = new Typed(typedRef.current, options);

        return () => {
            typed.destroy();
        };
    }, []);

    return (
        <div>
            <div className='w-full sm:w-3/12 flex flex-col justify-between items-center mx-auto p-6'>
                <img src={svg} alt='CopyBuddy.io Logo' className='w-1/2' />
            </div>
            <div className="flex flex-col md:flex-row items-center m-0 mb-0 sm:m-16 p-4 sm:p-20">
                <div className="flex flex-col sm:w-full md:w-1/2 md:ml-auto my-16 md:m-0">
                    <p className="text-3xl sm:text-4xl md:text-5xl mb-4 sm:mb-6">
                        <span ref={typedRef} />
                    </p>
                    <p className={`text-lg mb-4 sm:mb-6 fade-in ${showParagraph ? 'show' : ''}`}>
                        Share your prospect's LinkedIn profile URL,<br />and we'll write them a personalized message.
                    </p>
                    <div className={`fade-in ${showButton ? 'show' : ''}`}>
                        <button
                            type="button"
                            onClick={() => navigate('/signup')}
                            className="mb-3 rounded-full bg-custom-orange px-4 py-2.5 text-md font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2"
                        >
                            <img src={sparkles} alt="sparkles" className="w-5 inline-block transform -translate-y-0.5" />&nbsp;&nbsp;Sign up for CopyBuddy
                        </button>
                        {/* <p className="text-custom-free-text">&nbsp;&nbsp;First 3 are free :)</p> */}
                    </div>
                </div>
                <div className="flex flex-col sm:w-full md:w-1/2 md:ml-auto bg-white rounded-xl shadow-2xl overflow-hidden max-w-4xl mt-8 md:mt-0 mb-10">
                    <div className="md:flex">
                        <div className="p-4 sm:p-8">
                            <p className="block mt-1 text-lg leading-tight font-medium mb-3">Write personalized emails quickly</p>
                            <p className="mt-2">Hey there!<br /><br />
                                Researching prospects is time consuming. <br /><br />But with CopyBuddy, you'll have <b>personalized emails written in seconds.</b>
                                <br /><br />
                                See for yourself - we'll give you a refund if you don't love them.
                                <br /><br />
                                Adam Gusky<br />Founder @ CopyBuddy</p><br />
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex items-center justify-center font-bold'>
                <Featured />
            </div>
            <div>
                <Demo />
            </div>
            <div className='text-2xl flex items-center justify-center font-bold'>
                <Testimonials />
            </div>
            <div className='text-2xl flex items-center justify-center font-bold'>
                <Pricing />
            </div>
            <div className='text-2xl items-center justify-center font-bold'>
                <Faq />
            </div>
            <div className='text-2xl flex items-center justify-center font-bold'>
                <Footer />
            </div>
        </div>
    );
}

export default LandingPage;
